"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _InsertDriveFile = _interopRequireDefault(require("@material-ui/icons/InsertDriveFile"));

var _CloudDownload = _interopRequireDefault(require("@material-ui/icons/CloudDownload"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    fileListItemText: {
      maxWidth: '80%',
      padding: '0 16px'
    },
    thumbnail: {
      width: 40,
      height: 40
    },
    fileIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 40,
      height: 40,
      margin: 0,
      color: theme.palette.icon
    },
    badge: {
      top: 22,
      left: -6,
      right: 'auto',
      backgroundColor: theme.palette.background.paper
    },
    badgeIcon: {
      width: 20,
      height: 20,
      color: theme.palette.icon
    }
  };
});

var FileListItem = function FileListItem(_ref) {
  var label = _ref.label,
      fileUrl = _ref.fileUrl,
      fileType = _ref.fileType,
      description = _ref.description,
      interactive = _ref.interactive,
      isImage = _ref.isImage,
      onClickDownloadFile = _ref.onClickDownloadFile,
      onClickOpen = _ref.onClickOpen,
      translations = _ref.translations,
      hidden = _ref.hidden,
      eClasses = _ref.classes;
  var classes = useStyles({
    classes: eClasses
  });

  var t = _objectSpread({
    download: 'download'
  }, translations);

  var fileName = fileUrl && fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
  var secondaryText = description || fileName;

  var thumbnail = /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, {
    className: classes.fileIcon
  }, /*#__PURE__*/_react["default"].createElement(_InsertDriveFile["default"], null));

  if (isImage || (0, _helpers.isOfTypeImage)(fileType || fileName)) {
    thumbnail = /*#__PURE__*/_react["default"].createElement("img", {
      src: (0, _helpers.getResizedImage)(fileUrl, 'w=40&h=40&t=square'),
      alt: fileName,
      className: classes.thumbnail
    });
  }

  if (hidden) {
    thumbnail = /*#__PURE__*/_react["default"].createElement(_core.Badge, {
      classes: {
        badge: classes.badge
      },
      badgeContent: /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
        className: classes.badgeIcon
      })
    }, thumbnail);
  }

  return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: interactive,
    dense: true,
    onClick: onClickOpen,
    "data-file-url": fileUrl,
    className: classes.root
  }, thumbnail, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fileListItemText
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "subtitle1",
    noWrap: true,
    title: fileName
  }, label), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    color: "textSecondary",
    noWrap: true
  }, secondaryText)), /*#__PURE__*/_react["default"].createElement(_core.ListItemSecondaryAction, {
    className: classes.fileListItemAction
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: onClickDownloadFile,
    "data-url": fileUrl,
    title: t.download
  }, /*#__PURE__*/_react["default"].createElement(_CloudDownload["default"], null))));
};

FileListItem.propTypes = {
  description: _propTypes["default"].string,
  fileType: _propTypes["default"].string,
  fileUrl: _propTypes["default"].string.isRequired,
  hidden: _propTypes["default"].bool,
  interactive: _propTypes["default"].bool,
  isImage: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  onClickDownloadFile: _propTypes["default"].func,
  onClickOpen: _propTypes["default"].func,
  translations: _propTypes["default"].object
};
FileListItem.defaultProps = {
  description: null,
  interactive: false,
  hidden: false,
  isImage: false,
  onClickDownloadFile: null,
  onClickOpen: null,
  translations: {}
};
var _default = FileListItem;
exports["default"] = _default;